import { useTranslation } from "react-i18next";

const FLAGS: Record<string, string> = { cs: "🇨🇿", en: "🇬🇧", sk: "🇸🇰" };

export default function LanguageFlags() {
  const { i18n } = useTranslation();
  const activeLng = (i18n.resolvedLanguage || i18n.language || "").split("-")[0];
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      {Object.keys(i18n.options.resources || {}).map((lng) => {
        const isActive = activeLng === lng;
        return (
          <button
            key={lng}
            onClick={() => i18n.changeLanguage(lng)}
            title={lng.toUpperCase()}
            style={{
              border: "none", background: isActive ? "var(--accent)" : "transparent",
              borderRadius: "50%", width: 32, height: 32, cursor: "pointer",
              fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center",
              opacity: isActive ? 1 : 0.7,
              fontFamily: "'Noto Color Emoji', sans-serif",
            }}
          >
            {FLAGS[lng] ?? lng.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
